import { createGenericSlice } from './generic.slice'
import { RootState } from '@store/store'

export interface TemplateModel {
  id: string
  templateName: string
}

const {
  slice: templateSlice,
  thunks: templateThunks,
  adapter: templateAdapter,
} = createGenericSlice<TemplateModel>(
  'Template',
  'template',
  {} // Initial state can be customized if needed
)

export const {
  selectAll: selectAllTemplates, // ... other selectors
} = templateAdapter.getSelectors<RootState>(
  (state: RootState) => state.templates
)

export const { fetchAll: fetchAllTemplates } = templateThunks

export default templateSlice.reducer
